import React from 'react';
import '../App.css';

export default class Footer extends React.Component {

  render() {
    return (
      <div className='footerDiv'>
         About &#8226; Help &#8226; Privacy &#8226; Terms
         <br />
         &copy;2018 ugov
      </div>
    );
  }
}

